import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input
} from '@angular/core';
import { CommonModule } from '@angular/common';
import type { Signal } from '@angular/core';

import type { Direction } from '../../domain/direction';

@Component({
  imports: [
    CommonModule
  ],
  selector: 'td-wb-checkbox-group',
  templateUrl: 'checkbox-group.component.html',
  styleUrls: ['checkbox-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxGroupComponent {
  direction: Signal<Direction> = input<Direction>('horizontal');
}
